import useAppContext from 'flow/hooks/useAppContext';

import QuotaStatRow from './QuotaStatRow';

type Props = {
    total: number | null;
};

const QuotaLimitRow = ({ total }: Props) => {
    const { i18next } = useAppContext();

    return (
        <QuotaStatRow
            label="settings.usage.limit"
            value={
                total !== null
                    ? `${total} ${i18next.t('duration.minutes')}`
                    : undefined
            }
            skeletonWidth="w-24"
        />
    );
};

export default QuotaLimitRow;
